import { render, staticRenderFns } from "./ProcessnewEvaluation.vue?vue&type=template&id=f66f43bc&scoped=true"
import script from "./ProcessnewEvaluation.vue?vue&type=script&lang=js"
export * from "./ProcessnewEvaluation.vue?vue&type=script&lang=js"
import style0 from "./ProcessnewEvaluation.vue?vue&type=style&index=0&id=f66f43bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f43bc",
  null
  
)

export default component.exports